// AUTO-GÉNÉRÉ par `php bin/console app:nav:generate-ts` depuis App\Service\NavCatalog.
// NE PAS ÉDITER À LA MAIN. Toute modif de la nav se fait dans src/Service/NavCatalog.php.

export type NavTier = "account" | "premium";

export type NavRubriqueKey = "resultats" | "pronostics" | "statistiques" | "outils" | "guides";

export interface NavItem {
  /** Adresse de la page, sans ancre : état actif, rubrique et fil d'Ariane s'y appuient */
  path: string;
  /** Section de la page (« chauds-froids »), null pour la page entière */
  anchor: string | null;
  /** Lien affiché : path suivi de #anchor quand il y a une ancre */
  href: string;
  label: string;
  desc: string;
  /** Nom d'icône canonique (clé MagHeaderRenderer::icon), mappé vers lucide dans navIcons.ts */
  icon: string;
  /** null = accès libre */
  tier: NavTier | null;
  /** true = page Twig ou prérendue : <a href> plutôt que <Link to> */
  isStatic: boolean;
  /** Ce que le compte gratuit apporte pour cet outil (mur d'inscription) */
  gain: string | null;
  /** Aperçu de l'outil sous /images/outils/ */
  preview: string | null;
}

export interface NavRubrique {
  key: NavRubriqueKey;
  label: string;
  /** Libellé de la barre mobile (« Stats ») */
  shortLabel: string;
  icon: string;
  hubPath: string;
  desc: string;
  /** Menu déroulant : 6 liens au plus */
  menu: NavItem[];
  /** Lien « Tout voir » du menu, null quand le menu montre déjà toute la rubrique */
  toutVoir: string | null;
  /** Ancre du lien « Tout voir » : nom de la liste visée (« Tous les outils ») */
  toutVoirLabel: string;
  /** Toutes les pages de la rubrique */
  items: NavItem[];
}

export interface NavFooterColumn {
  key: NavRubriqueKey;
  label: string;
  hubPath: string;
  links: NavItem[];
}

export interface NavFooter {
  columns: NavFooterColumn[];
  kenometric: NavItem[];
  legal: NavItem[];
}

export const NAV_RUBRIQUES: NavRubrique[] = [
    {
        "key": "resultats",
        "label": "Résultats",
        "shortLabel": "Résultats",
        "icon": "history",
        "hubPath": "/tirage-du-jour/",
        "desc": "Le tirage du soir et tous les tirages depuis novembre 2025.",
        "menu": [
            {
                "path": "/tirage-du-jour/",
                "anchor": null,
                "href": "/tirage-du-jour/",
                "label": "Dernier tirage",
                "desc": "Le résultat du soir, analysé",
                "icon": "target",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/derniers-tirages-keno/",
                "anchor": null,
                "href": "/derniers-tirages-keno/",
                "label": "Derniers tirages",
                "desc": "Tous les résultats, 50 par défaut, et le calendrier",
                "icon": "history",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/grille-matricielle-keno/",
                "anchor": null,
                "href": "/grille-matricielle-keno/",
                "label": "Grille matricielle",
                "desc": "Tous les tirages croisés avec les 56 numéros",
                "icon": "grid-2x2",
                "tier": null,
                "isStatic": false,
                "gain": null,
                "preview": null
            }
        ],
        "toutVoir": null,
        "toutVoirLabel": "Tous les résultats",
        "items": [
            {
                "path": "/tirage-du-jour/",
                "anchor": null,
                "href": "/tirage-du-jour/",
                "label": "Dernier tirage",
                "desc": "Le résultat du soir, analysé",
                "icon": "target",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/derniers-tirages-keno/",
                "anchor": null,
                "href": "/derniers-tirages-keno/",
                "label": "Derniers tirages",
                "desc": "Tous les résultats, 50 par défaut, et le calendrier",
                "icon": "history",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/grille-matricielle-keno/",
                "anchor": null,
                "href": "/grille-matricielle-keno/",
                "label": "Grille matricielle",
                "desc": "Tous les tirages croisés avec les 56 numéros",
                "icon": "grid-2x2",
                "tier": null,
                "isStatic": false,
                "gain": null,
                "preview": null
            }
        ]
    },
    {
        "key": "pronostics",
        "label": "Pronostics",
        "shortLabel": "Pronostics",
        "icon": "star",
        "hubPath": "/pronostics-keno/",
        "desc": "Les listes du soir et l'heure du prochain tirage.",
        "menu": [
            {
                "path": "/pronostics-keno/",
                "anchor": null,
                "href": "/pronostics-keno/",
                "label": "Pronostics du soir",
                "desc": "Six listes calculées pour le tirage de ce soir",
                "icon": "star",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/prochain-tirage/",
                "anchor": null,
                "href": "/prochain-tirage/",
                "label": "Prochain tirage",
                "desc": "L'heure du tirage et le dernier résultat",
                "icon": "calendar",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            }
        ],
        "toutVoir": null,
        "toutVoirLabel": "Tous les pronostics",
        "items": [
            {
                "path": "/pronostics-keno/",
                "anchor": null,
                "href": "/pronostics-keno/",
                "label": "Pronostics du soir",
                "desc": "Six listes calculées pour le tirage de ce soir",
                "icon": "star",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/prochain-tirage/",
                "anchor": null,
                "href": "/prochain-tirage/",
                "label": "Prochain tirage",
                "desc": "L'heure du tirage et le dernier résultat",
                "icon": "calendar",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            }
        ]
    },
    {
        "key": "statistiques",
        "label": "Statistiques",
        "shortLabel": "Stats",
        "icon": "bar-chart",
        "hubPath": "/keno-statistiques/",
        "desc": "Fréquences, écarts et records, recalculés après chaque tirage.",
        "menu": [
            {
                "path": "/keno-statistiques/",
                "anchor": null,
                "href": "/keno-statistiques/",
                "label": "Statistiques du Keno",
                "desc": "Semaine, mois, chauds et froids, baromètre des écarts et tableau des 56 numéros",
                "icon": "table",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/keno-statistiques/",
                "anchor": "chauds-froids",
                "href": "/keno-statistiques/#chauds-froids",
                "label": "Chauds et froids",
                "desc": "Fréquence de sortie des numéros depuis novembre 2025, comparée à la fréquence théorique",
                "icon": "table",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/keno-statistiques/",
                "anchor": "tableau-56",
                "href": "/keno-statistiques/#tableau-56",
                "label": "Les 56 numéros",
                "desc": "Sorties, écarts et records de chaque numéro, sur tout l'historique",
                "icon": "table",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/numeros-plus-sortis-keno/",
                "anchor": null,
                "href": "/numeros-plus-sortis-keno/",
                "label": "Top sur une période",
                "desc": "Les plus sortis entre deux dates",
                "icon": "calendar",
                "tier": null,
                "isStatic": false,
                "gain": null,
                "preview": null
            },
            {
                "path": "/taux-sortie-numeros-keno/",
                "anchor": null,
                "href": "/taux-sortie-numeros-keno/",
                "label": "Taux de sortie",
                "desc": "La fréquence réelle face au taux théorique de 28,57 %",
                "icon": "bar-chart",
                "tier": null,
                "isStatic": false,
                "gain": null,
                "preview": null
            },
            {
                "path": "/relations/",
                "anchor": null,
                "href": "/relations/",
                "label": "Relations",
                "desc": "Les numéros qui sortent ensemble",
                "icon": "link",
                "tier": "account",
                "isStatic": false,
                "gain": "Les numéros qui sortent le plus souvent avec celui de votre choix dans les tirages passés.",
                "preview": "/images/outils/relations.webp"
            }
        ],
        "toutVoir": "/keno-statistiques/#autres",
        "toutVoirLabel": "Toutes les statistiques",
        "items": [
            {
                "path": "/keno-statistiques/",
                "anchor": null,
                "href": "/keno-statistiques/",
                "label": "Statistiques du Keno",
                "desc": "Semaine, mois, chauds et froids, baromètre des écarts et tableau des 56 numéros",
                "icon": "table",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/numeros-plus-sortis-keno/",
                "anchor": null,
                "href": "/numeros-plus-sortis-keno/",
                "label": "Top sur une période",
                "desc": "Les plus sortis entre deux dates",
                "icon": "calendar",
                "tier": null,
                "isStatic": false,
                "gain": null,
                "preview": null
            },
            {
                "path": "/taux-sortie-numeros-keno/",
                "anchor": null,
                "href": "/taux-sortie-numeros-keno/",
                "label": "Taux de sortie",
                "desc": "La fréquence réelle face au taux théorique de 28,57 %",
                "icon": "bar-chart",
                "tier": null,
                "isStatic": false,
                "gain": null,
                "preview": null
            },
            {
                "path": "/relations/",
                "anchor": null,
                "href": "/relations/",
                "label": "Relations",
                "desc": "Les numéros qui sortent ensemble",
                "icon": "link",
                "tier": "account",
                "isStatic": false,
                "gain": "Les numéros qui sortent le plus souvent avec celui de votre choix dans les tirages passés.",
                "preview": "/images/outils/relations.webp"
            },
            {
                "path": "/numeros-signature-keno/",
                "anchor": null,
                "href": "/numeros-signature-keno/",
                "label": "Numéros signature",
                "desc": "Les numéros dominants sur plusieurs périodes",
                "icon": "activity",
                "tier": null,
                "isStatic": false,
                "gain": null,
                "preview": null
            }
        ]
    },
    {
        "key": "outils",
        "label": "Outils",
        "shortLabel": "Outils",
        "icon": "sparkles",
        "hubPath": "/outils-keno/",
        "desc": "Préparer sa grille, calculer, analyser l'historique.",
        "menu": [
            {
                "path": "/generateur-grille-keno/",
                "anchor": null,
                "href": "/generateur-grille-keno/",
                "label": "Générateur de grilles",
                "desc": "Une grille sans compte, le générateur complet avec un compte gratuit",
                "icon": "sparkles",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/reducteur/",
                "anchor": null,
                "href": "/reducteur/",
                "label": "Système réducteur",
                "desc": "Couvrir plus de numéros avec moins de grilles",
                "icon": "shield",
                "tier": "premium",
                "isStatic": false,
                "gain": "Le système réducteur : couvrez une sélection de numéros avec moins de grilles. Inclus dans Premium, à essayer gratuitement avec votre compte, sans carte bancaire.",
                "preview": "/images/outils/reducteur.webp"
            },
            {
                "path": "/tests/",
                "anchor": null,
                "href": "/tests/",
                "label": "Tester ma grille",
                "desc": "Votre grille confrontée à l'historique",
                "icon": "check-check",
                "tier": "premium",
                "isStatic": false,
                "gain": "Votre grille confrontée aux tirages passés : combien de bons numéros elle aurait eus, tirage par tirage. Inclus dans Premium, à essayer gratuitement avec votre compte, sans carte bancaire.",
                "preview": "/images/outils/tests.webp"
            },
            {
                "path": "/analyse-combinaison-keno/",
                "anchor": null,
                "href": "/analyse-combinaison-keno/",
                "label": "Analyse de combinaison",
                "desc": "Depuis combien de tirages votre combinaison n'est pas sortie",
                "icon": "target",
                "tier": null,
                "isStatic": false,
                "gain": null,
                "preview": null
            },
            {
                "path": "/calculateur-gains-keno/",
                "anchor": null,
                "href": "/calculateur-gains-keno/",
                "label": "Calculateur de gains",
                "desc": "Ce que rapporte chaque nombre de bons numéros",
                "icon": "calculator",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/labo/",
                "anchor": null,
                "href": "/labo/",
                "label": "Labo de simulation",
                "desc": "Vos stratégies testées sur les tirages réels",
                "icon": "flask",
                "tier": null,
                "isStatic": false,
                "gain": null,
                "preview": null
            }
        ],
        "toutVoir": "/outils-keno/",
        "toutVoirLabel": "Tous les outils",
        "items": [
            {
                "path": "/outils-keno/",
                "anchor": null,
                "href": "/outils-keno/",
                "label": "Tous les outils",
                "desc": "Les outils rangés par besoin, avec leur accès",
                "icon": "grid",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/generateur-grille-keno/",
                "anchor": null,
                "href": "/generateur-grille-keno/",
                "label": "Générateur de grilles",
                "desc": "Une grille sans compte, le générateur complet avec un compte gratuit",
                "icon": "sparkles",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/reducteur/",
                "anchor": null,
                "href": "/reducteur/",
                "label": "Système réducteur",
                "desc": "Couvrir plus de numéros avec moins de grilles",
                "icon": "shield",
                "tier": "premium",
                "isStatic": false,
                "gain": "Le système réducteur : couvrez une sélection de numéros avec moins de grilles. Inclus dans Premium, à essayer gratuitement avec votre compte, sans carte bancaire.",
                "preview": "/images/outils/reducteur.webp"
            },
            {
                "path": "/tests/",
                "anchor": null,
                "href": "/tests/",
                "label": "Tester ma grille",
                "desc": "Votre grille confrontée à l'historique",
                "icon": "check-check",
                "tier": "premium",
                "isStatic": false,
                "gain": "Votre grille confrontée aux tirages passés : combien de bons numéros elle aurait eus, tirage par tirage. Inclus dans Premium, à essayer gratuitement avec votre compte, sans carte bancaire.",
                "preview": "/images/outils/tests.webp"
            },
            {
                "path": "/analyse-combinaison-keno/",
                "anchor": null,
                "href": "/analyse-combinaison-keno/",
                "label": "Analyse de combinaison",
                "desc": "Depuis combien de tirages votre combinaison n'est pas sortie",
                "icon": "target",
                "tier": null,
                "isStatic": false,
                "gain": null,
                "preview": null
            },
            {
                "path": "/calculateur-gains-keno/",
                "anchor": null,
                "href": "/calculateur-gains-keno/",
                "label": "Calculateur de gains",
                "desc": "Ce que rapporte chaque nombre de bons numéros",
                "icon": "calculator",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/simulateur-probabilites-keno/",
                "anchor": null,
                "href": "/simulateur-probabilites-keno/",
                "label": "Simulateur de probabilités",
                "desc": "Vos chances selon le nombre de numéros joués",
                "icon": "dices",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/comparateur/",
                "anchor": null,
                "href": "/comparateur/",
                "label": "Comparateur",
                "desc": "Deux numéros côte à côte",
                "icon": "compare",
                "tier": "account",
                "isStatic": false,
                "gain": "Deux numéros côte à côte : sorties, écarts et tendance récente.",
                "preview": "/images/outils/comparateur.webp"
            },
            {
                "path": "/quartets/",
                "anchor": null,
                "href": "/quartets/",
                "label": "Quartets",
                "desc": "Les groupes de 4 numéros qui reviennent",
                "icon": "grid-2x2",
                "tier": "premium",
                "isStatic": false,
                "gain": "Les quartets qui sortent le plus souvent, par numéro ou par couple. Inclus dans Premium, à essayer gratuitement avec votre compte, sans carte bancaire.",
                "preview": "/images/outils/quartets.webp"
            },
            {
                "path": "/structures/",
                "anchor": null,
                "href": "/structures/",
                "label": "Structures",
                "desc": "Pair et impair, bas et hauts, dizaines",
                "icon": "grid",
                "tier": "account",
                "isStatic": false,
                "gain": "La répartition pair et impair, bas et hauts, dizaines et finales de chaque tirage, et les profils qui reviennent le plus.",
                "preview": "/images/outils/structures.webp"
            },
            {
                "path": "/multiplicateurs/",
                "anchor": null,
                "href": "/multiplicateurs/",
                "label": "Multiplicateurs",
                "desc": "Les multiplicateurs sur tout l'historique",
                "icon": "coins",
                "tier": "account",
                "isStatic": false,
                "gain": "La fréquence de chaque multiplicateur sur l'historique des tirages : écarts, séries et comparaison avec la répartition théorique.",
                "preview": "/images/outils/multiplicateurs.webp"
            },
            {
                "path": "/numeros-communs/",
                "anchor": null,
                "href": "/numeros-communs/",
                "label": "Numéros communs",
                "desc": "Les numéros qui se répètent d'un tirage à l'autre",
                "icon": "repeat",
                "tier": "account",
                "isStatic": false,
                "gain": "Combien de numéros se répètent d'un tirage à l'autre, comparé à la répartition théorique. Le tableau détaillé et son export sont inclus dans Premium.",
                "preview": "/images/outils/numeros-communs.webp"
            },
            {
                "path": "/labo/",
                "anchor": null,
                "href": "/labo/",
                "label": "Labo de simulation",
                "desc": "Vos stratégies testées sur les tirages réels",
                "icon": "flask",
                "tier": null,
                "isStatic": false,
                "gain": null,
                "preview": null
            },
            {
                "path": "/exports/",
                "anchor": null,
                "href": "/exports/",
                "label": "Export des tirages",
                "desc": "CSV, Excel et PDF de la période choisie",
                "icon": "download",
                "tier": "premium",
                "isStatic": false,
                "gain": "Les tirages et les statistiques de la période choisie à télécharger : CSV, Excel prêt à l'emploi ou PDF à imprimer, avec Premium.",
                "preview": "/images/outils/exports.webp"
            }
        ]
    },
    {
        "key": "guides",
        "label": "Guides",
        "shortLabel": "Guides",
        "icon": "book",
        "hubPath": "/keno-regles/",
        "desc": "Comprendre le jeu, simplement.",
        "menu": [
            {
                "path": "/keno-regles/",
                "anchor": null,
                "href": "/keno-regles/",
                "label": "Règles du Keno",
                "desc": "La formule 2025 expliquée simplement",
                "icon": "book",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/keno-probabilites/",
                "anchor": null,
                "href": "/keno-probabilites/",
                "label": "Probabilités",
                "desc": "Vos chances pour chaque grille, de 4 à 10 numéros",
                "icon": "dices",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/comment-gagner-keno/",
                "anchor": null,
                "href": "/comment-gagner-keno/",
                "label": "Comment gagner au Keno",
                "desc": "Ce qui est possible et ce qui ne l'est pas",
                "icon": "target",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/combien-numeros-jouer-keno/",
                "anchor": null,
                "href": "/combien-numeros-jouer-keno/",
                "label": "Combien de numéros jouer",
                "desc": "De 4 à 10 numéros : que choisir",
                "icon": "grid",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/keno-mythes-vs-realite/",
                "anchor": null,
                "href": "/keno-mythes-vs-realite/",
                "label": "Mythes et réalité",
                "desc": "Les idées reçues passées au crible",
                "icon": "activity",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/guide-systemes-reducteurs/",
                "anchor": null,
                "href": "/guide-systemes-reducteurs/",
                "label": "Guide des réducteurs",
                "desc": "Comprendre les systèmes réducteurs",
                "icon": "book",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            }
        ],
        "toutVoir": "/keno-regles/#tous-guides",
        "toutVoirLabel": "Tous les guides",
        "items": [
            {
                "path": "/keno-regles/",
                "anchor": null,
                "href": "/keno-regles/",
                "label": "Règles du Keno",
                "desc": "La formule 2025 expliquée simplement",
                "icon": "book",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/keno-probabilites/",
                "anchor": null,
                "href": "/keno-probabilites/",
                "label": "Probabilités",
                "desc": "Vos chances pour chaque grille, de 4 à 10 numéros",
                "icon": "dices",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/comment-gagner-keno/",
                "anchor": null,
                "href": "/comment-gagner-keno/",
                "label": "Comment gagner au Keno",
                "desc": "Ce qui est possible et ce qui ne l'est pas",
                "icon": "target",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/combien-numeros-jouer-keno/",
                "anchor": null,
                "href": "/combien-numeros-jouer-keno/",
                "label": "Combien de numéros jouer",
                "desc": "De 4 à 10 numéros : que choisir",
                "icon": "grid",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/keno-mythes-vs-realite/",
                "anchor": null,
                "href": "/keno-mythes-vs-realite/",
                "label": "Mythes et réalité",
                "desc": "Les idées reçues passées au crible",
                "icon": "activity",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/guide-systemes-reducteurs/",
                "anchor": null,
                "href": "/guide-systemes-reducteurs/",
                "label": "Guide des réducteurs",
                "desc": "Comprendre les systèmes réducteurs",
                "icon": "book",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/loi-hypergeometrique-keno/",
                "anchor": null,
                "href": "/loi-hypergeometrique-keno/",
                "label": "Loi hypergéométrique",
                "desc": "Le calcul derrière les probabilités du Keno",
                "icon": "calculator",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/gagner-keno-4-numeros/",
                "anchor": null,
                "href": "/gagner-keno-4-numeros/",
                "label": "Jouer 4 numéros",
                "desc": "Probabilités et gains avec 4 numéros",
                "icon": "target",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/gagner-keno-5-numeros/",
                "anchor": null,
                "href": "/gagner-keno-5-numeros/",
                "label": "Jouer 5 numéros",
                "desc": "Probabilités et gains avec 5 numéros",
                "icon": "target",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/gagner-keno-6-numeros/",
                "anchor": null,
                "href": "/gagner-keno-6-numeros/",
                "label": "Jouer 6 numéros",
                "desc": "Probabilités et gains avec 6 numéros",
                "icon": "target",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/gagner-keno-7-numeros/",
                "anchor": null,
                "href": "/gagner-keno-7-numeros/",
                "label": "Jouer 7 numéros",
                "desc": "Probabilités et gains avec 7 numéros",
                "icon": "target",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/gagner-keno-8-numeros/",
                "anchor": null,
                "href": "/gagner-keno-8-numeros/",
                "label": "Jouer 8 numéros",
                "desc": "Probabilités et gains avec 8 numéros",
                "icon": "target",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/gagner-keno-9-numeros/",
                "anchor": null,
                "href": "/gagner-keno-9-numeros/",
                "label": "Jouer 9 numéros",
                "desc": "Probabilités et gains avec 9 numéros",
                "icon": "target",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/gagner-keno-10-numeros/",
                "anchor": null,
                "href": "/gagner-keno-10-numeros/",
                "label": "Jouer 10 numéros",
                "desc": "Probabilités et gains avec 10 numéros",
                "icon": "target",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/comparatif-nouvelle-formule-keno/",
                "anchor": null,
                "href": "/comparatif-nouvelle-formule-keno/",
                "label": "Avant et après 2025",
                "desc": "Ce qui a changé avec la nouvelle formule",
                "icon": "repeat",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            },
            {
                "path": "/jeu-responsable/",
                "anchor": null,
                "href": "/jeu-responsable/",
                "label": "Jeu responsable",
                "desc": "Garder le jeu un plaisir",
                "icon": "shield",
                "tier": null,
                "isStatic": true,
                "gain": null,
                "preview": null
            }
        ]
    }
];

export const NAV_FOOTER: NavFooter = {
    "columns": [
        {
            "key": "resultats",
            "label": "Résultats",
            "hubPath": "/tirage-du-jour/",
            "links": [
                {
                    "path": "/derniers-tirages-keno/",
                    "anchor": null,
                    "href": "/derniers-tirages-keno/",
                    "label": "Derniers tirages",
                    "desc": "Tous les résultats, 50 par défaut, et le calendrier",
                    "icon": "history",
                    "tier": null,
                    "isStatic": true,
                    "gain": null,
                    "preview": null
                }
            ]
        },
        {
            "key": "pronostics",
            "label": "Pronostics",
            "hubPath": "/pronostics-keno/",
            "links": [
                {
                    "path": "/prochain-tirage/",
                    "anchor": null,
                    "href": "/prochain-tirage/",
                    "label": "Prochain tirage",
                    "desc": "L'heure du tirage et le dernier résultat",
                    "icon": "calendar",
                    "tier": null,
                    "isStatic": true,
                    "gain": null,
                    "preview": null
                }
            ]
        },
        {
            "key": "statistiques",
            "label": "Statistiques",
            "hubPath": "/keno-statistiques/",
            "links": [
                {
                    "path": "/taux-sortie-numeros-keno/",
                    "anchor": null,
                    "href": "/taux-sortie-numeros-keno/",
                    "label": "Taux de sortie",
                    "desc": "La fréquence réelle face au taux théorique de 28,57 %",
                    "icon": "bar-chart",
                    "tier": null,
                    "isStatic": false,
                    "gain": null,
                    "preview": null
                },
                {
                    "path": "/numeros-plus-sortis-keno/",
                    "anchor": null,
                    "href": "/numeros-plus-sortis-keno/",
                    "label": "Top sur une période",
                    "desc": "Les plus sortis entre deux dates",
                    "icon": "calendar",
                    "tier": null,
                    "isStatic": false,
                    "gain": null,
                    "preview": null
                },
                {
                    "path": "/numeros-signature-keno/",
                    "anchor": null,
                    "href": "/numeros-signature-keno/",
                    "label": "Numéros signature",
                    "desc": "Les numéros dominants sur plusieurs périodes",
                    "icon": "activity",
                    "tier": null,
                    "isStatic": false,
                    "gain": null,
                    "preview": null
                }
            ]
        },
        {
            "key": "outils",
            "label": "Outils",
            "hubPath": "/outils-keno/",
            "links": [
                {
                    "path": "/generateur-grille-keno/",
                    "anchor": null,
                    "href": "/generateur-grille-keno/",
                    "label": "Générateur de grilles",
                    "desc": "Une grille sans compte, le générateur complet avec un compte gratuit",
                    "icon": "sparkles",
                    "tier": null,
                    "isStatic": true,
                    "gain": null,
                    "preview": null
                },
                {
                    "path": "/calculateur-gains-keno/",
                    "anchor": null,
                    "href": "/calculateur-gains-keno/",
                    "label": "Calculateur de gains",
                    "desc": "Ce que rapporte chaque nombre de bons numéros",
                    "icon": "calculator",
                    "tier": null,
                    "isStatic": true,
                    "gain": null,
                    "preview": null
                },
                {
                    "path": "/simulateur-probabilites-keno/",
                    "anchor": null,
                    "href": "/simulateur-probabilites-keno/",
                    "label": "Simulateur de probabilités",
                    "desc": "Vos chances selon le nombre de numéros joués",
                    "icon": "dices",
                    "tier": null,
                    "isStatic": true,
                    "gain": null,
                    "preview": null
                },
                {
                    "path": "/analyse-combinaison-keno/",
                    "anchor": null,
                    "href": "/analyse-combinaison-keno/",
                    "label": "Analyse de combinaison",
                    "desc": "Depuis combien de tirages votre combinaison n'est pas sortie",
                    "icon": "target",
                    "tier": null,
                    "isStatic": false,
                    "gain": null,
                    "preview": null
                },
                {
                    "path": "/labo/",
                    "anchor": null,
                    "href": "/labo/",
                    "label": "Labo de simulation",
                    "desc": "Vos stratégies testées sur les tirages réels",
                    "icon": "flask",
                    "tier": null,
                    "isStatic": false,
                    "gain": null,
                    "preview": null
                }
            ]
        },
        {
            "key": "guides",
            "label": "Guides",
            "hubPath": "/keno-regles/",
            "links": [
                {
                    "path": "/loi-hypergeometrique-keno/",
                    "anchor": null,
                    "href": "/loi-hypergeometrique-keno/",
                    "label": "Loi hypergéométrique",
                    "desc": "Le calcul derrière les probabilités du Keno",
                    "icon": "calculator",
                    "tier": null,
                    "isStatic": true,
                    "gain": null,
                    "preview": null
                },
                {
                    "path": "/comparatif-nouvelle-formule-keno/",
                    "anchor": null,
                    "href": "/comparatif-nouvelle-formule-keno/",
                    "label": "Avant et après 2025",
                    "desc": "Ce qui a changé avec la nouvelle formule",
                    "icon": "repeat",
                    "tier": null,
                    "isStatic": true,
                    "gain": null,
                    "preview": null
                },
                {
                    "path": "/jeu-responsable/",
                    "anchor": null,
                    "href": "/jeu-responsable/",
                    "label": "Jeu responsable",
                    "desc": "Garder le jeu un plaisir",
                    "icon": "shield",
                    "tier": null,
                    "isStatic": true,
                    "gain": null,
                    "preview": null
                }
            ]
        }
    ],
    "kenometric": [
        {
            "path": "/tarifs/",
            "anchor": null,
            "href": "/tarifs/",
            "label": "Tarifs",
            "desc": "Le compte gratuit et les formules Premium",
            "icon": "coins",
            "tier": null,
            "isStatic": false,
            "gain": null,
            "preview": null
        },
        {
            "path": "/contact/",
            "anchor": null,
            "href": "/contact/",
            "label": "Contact",
            "desc": "Une question, une remarque",
            "icon": "link",
            "tier": null,
            "isStatic": false,
            "gain": null,
            "preview": null
        },
        {
            "path": "/donnees-keno-open-data/",
            "anchor": null,
            "href": "/donnees-keno-open-data/",
            "label": "Données ouvertes",
            "desc": "L'historique en CSV et JSON, licence CC-BY 4.0",
            "icon": "download",
            "tier": null,
            "isStatic": true,
            "gain": null,
            "preview": null
        },
        {
            "path": "/alternative-kenolab/",
            "anchor": null,
            "href": "/alternative-kenolab/",
            "label": "Alternative à KenoLab",
            "desc": "KenoMetric face à KenoLab",
            "icon": "compare",
            "tier": null,
            "isStatic": true,
            "gain": null,
            "preview": null
        },
        {
            "path": "/alternative-secrets-du-jeu/",
            "anchor": null,
            "href": "/alternative-secrets-du-jeu/",
            "label": "Alternative à Secrets du Jeu",
            "desc": "KenoMetric face à Secrets du Jeu",
            "icon": "compare",
            "tier": null,
            "isStatic": true,
            "gain": null,
            "preview": null
        }
    ],
    "legal": [
        {
            "path": "/legal/",
            "anchor": null,
            "href": "/legal/",
            "label": "Mentions légales",
            "desc": "Éditeur et hébergeur du site",
            "icon": "book",
            "tier": null,
            "isStatic": true,
            "gain": null,
            "preview": null
        },
        {
            "path": "/cgu/",
            "anchor": null,
            "href": "/cgu/",
            "label": "CGU",
            "desc": "Conditions générales d'utilisation",
            "icon": "book",
            "tier": null,
            "isStatic": true,
            "gain": null,
            "preview": null
        },
        {
            "path": "/cgv/",
            "anchor": null,
            "href": "/cgv/",
            "label": "CGV",
            "desc": "Conditions générales de vente",
            "icon": "book",
            "tier": null,
            "isStatic": true,
            "gain": null,
            "preview": null
        },
        {
            "path": "/confidentialite/",
            "anchor": null,
            "href": "/confidentialite/",
            "label": "Confidentialité",
            "desc": "Vos données et vos droits",
            "icon": "shield",
            "tier": null,
            "isStatic": true,
            "gain": null,
            "preview": null
        }
    ]
};

/** Tous les éléments : rubriques, colonnes KenoMetric et Légal, routes de l'application (mur d'inscription). */
export const NAV_ITEMS: NavItem[] = [
    {
        "path": "/tirage-du-jour/",
        "anchor": null,
        "href": "/tirage-du-jour/",
        "label": "Dernier tirage",
        "desc": "Le résultat du soir, analysé",
        "icon": "target",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/derniers-tirages-keno/",
        "anchor": null,
        "href": "/derniers-tirages-keno/",
        "label": "Derniers tirages",
        "desc": "Tous les résultats, 50 par défaut, et le calendrier",
        "icon": "history",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/grille-matricielle-keno/",
        "anchor": null,
        "href": "/grille-matricielle-keno/",
        "label": "Grille matricielle",
        "desc": "Tous les tirages croisés avec les 56 numéros",
        "icon": "grid-2x2",
        "tier": null,
        "isStatic": false,
        "gain": null,
        "preview": null
    },
    {
        "path": "/pronostics-keno/",
        "anchor": null,
        "href": "/pronostics-keno/",
        "label": "Pronostics du soir",
        "desc": "Six listes calculées pour le tirage de ce soir",
        "icon": "star",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/prochain-tirage/",
        "anchor": null,
        "href": "/prochain-tirage/",
        "label": "Prochain tirage",
        "desc": "L'heure du tirage et le dernier résultat",
        "icon": "calendar",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/keno-statistiques/",
        "anchor": null,
        "href": "/keno-statistiques/",
        "label": "Statistiques du Keno",
        "desc": "Semaine, mois, chauds et froids, baromètre des écarts et tableau des 56 numéros",
        "icon": "table",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/numeros-plus-sortis-keno/",
        "anchor": null,
        "href": "/numeros-plus-sortis-keno/",
        "label": "Top sur une période",
        "desc": "Les plus sortis entre deux dates",
        "icon": "calendar",
        "tier": null,
        "isStatic": false,
        "gain": null,
        "preview": null
    },
    {
        "path": "/taux-sortie-numeros-keno/",
        "anchor": null,
        "href": "/taux-sortie-numeros-keno/",
        "label": "Taux de sortie",
        "desc": "La fréquence réelle face au taux théorique de 28,57 %",
        "icon": "bar-chart",
        "tier": null,
        "isStatic": false,
        "gain": null,
        "preview": null
    },
    {
        "path": "/relations/",
        "anchor": null,
        "href": "/relations/",
        "label": "Relations",
        "desc": "Les numéros qui sortent ensemble",
        "icon": "link",
        "tier": "account",
        "isStatic": false,
        "gain": "Les numéros qui sortent le plus souvent avec celui de votre choix dans les tirages passés.",
        "preview": "/images/outils/relations.webp"
    },
    {
        "path": "/numeros-signature-keno/",
        "anchor": null,
        "href": "/numeros-signature-keno/",
        "label": "Numéros signature",
        "desc": "Les numéros dominants sur plusieurs périodes",
        "icon": "activity",
        "tier": null,
        "isStatic": false,
        "gain": null,
        "preview": null
    },
    {
        "path": "/outils-keno/",
        "anchor": null,
        "href": "/outils-keno/",
        "label": "Tous les outils",
        "desc": "Les outils rangés par besoin, avec leur accès",
        "icon": "grid",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/generateur-grille-keno/",
        "anchor": null,
        "href": "/generateur-grille-keno/",
        "label": "Générateur de grilles",
        "desc": "Une grille sans compte, le générateur complet avec un compte gratuit",
        "icon": "sparkles",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/reducteur/",
        "anchor": null,
        "href": "/reducteur/",
        "label": "Système réducteur",
        "desc": "Couvrir plus de numéros avec moins de grilles",
        "icon": "shield",
        "tier": "premium",
        "isStatic": false,
        "gain": "Le système réducteur : couvrez une sélection de numéros avec moins de grilles. Inclus dans Premium, à essayer gratuitement avec votre compte, sans carte bancaire.",
        "preview": "/images/outils/reducteur.webp"
    },
    {
        "path": "/tests/",
        "anchor": null,
        "href": "/tests/",
        "label": "Tester ma grille",
        "desc": "Votre grille confrontée à l'historique",
        "icon": "check-check",
        "tier": "premium",
        "isStatic": false,
        "gain": "Votre grille confrontée aux tirages passés : combien de bons numéros elle aurait eus, tirage par tirage. Inclus dans Premium, à essayer gratuitement avec votre compte, sans carte bancaire.",
        "preview": "/images/outils/tests.webp"
    },
    {
        "path": "/analyse-combinaison-keno/",
        "anchor": null,
        "href": "/analyse-combinaison-keno/",
        "label": "Analyse de combinaison",
        "desc": "Depuis combien de tirages votre combinaison n'est pas sortie",
        "icon": "target",
        "tier": null,
        "isStatic": false,
        "gain": null,
        "preview": null
    },
    {
        "path": "/calculateur-gains-keno/",
        "anchor": null,
        "href": "/calculateur-gains-keno/",
        "label": "Calculateur de gains",
        "desc": "Ce que rapporte chaque nombre de bons numéros",
        "icon": "calculator",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/simulateur-probabilites-keno/",
        "anchor": null,
        "href": "/simulateur-probabilites-keno/",
        "label": "Simulateur de probabilités",
        "desc": "Vos chances selon le nombre de numéros joués",
        "icon": "dices",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/comparateur/",
        "anchor": null,
        "href": "/comparateur/",
        "label": "Comparateur",
        "desc": "Deux numéros côte à côte",
        "icon": "compare",
        "tier": "account",
        "isStatic": false,
        "gain": "Deux numéros côte à côte : sorties, écarts et tendance récente.",
        "preview": "/images/outils/comparateur.webp"
    },
    {
        "path": "/quartets/",
        "anchor": null,
        "href": "/quartets/",
        "label": "Quartets",
        "desc": "Les groupes de 4 numéros qui reviennent",
        "icon": "grid-2x2",
        "tier": "premium",
        "isStatic": false,
        "gain": "Les quartets qui sortent le plus souvent, par numéro ou par couple. Inclus dans Premium, à essayer gratuitement avec votre compte, sans carte bancaire.",
        "preview": "/images/outils/quartets.webp"
    },
    {
        "path": "/structures/",
        "anchor": null,
        "href": "/structures/",
        "label": "Structures",
        "desc": "Pair et impair, bas et hauts, dizaines",
        "icon": "grid",
        "tier": "account",
        "isStatic": false,
        "gain": "La répartition pair et impair, bas et hauts, dizaines et finales de chaque tirage, et les profils qui reviennent le plus.",
        "preview": "/images/outils/structures.webp"
    },
    {
        "path": "/multiplicateurs/",
        "anchor": null,
        "href": "/multiplicateurs/",
        "label": "Multiplicateurs",
        "desc": "Les multiplicateurs sur tout l'historique",
        "icon": "coins",
        "tier": "account",
        "isStatic": false,
        "gain": "La fréquence de chaque multiplicateur sur l'historique des tirages : écarts, séries et comparaison avec la répartition théorique.",
        "preview": "/images/outils/multiplicateurs.webp"
    },
    {
        "path": "/numeros-communs/",
        "anchor": null,
        "href": "/numeros-communs/",
        "label": "Numéros communs",
        "desc": "Les numéros qui se répètent d'un tirage à l'autre",
        "icon": "repeat",
        "tier": "account",
        "isStatic": false,
        "gain": "Combien de numéros se répètent d'un tirage à l'autre, comparé à la répartition théorique. Le tableau détaillé et son export sont inclus dans Premium.",
        "preview": "/images/outils/numeros-communs.webp"
    },
    {
        "path": "/labo/",
        "anchor": null,
        "href": "/labo/",
        "label": "Labo de simulation",
        "desc": "Vos stratégies testées sur les tirages réels",
        "icon": "flask",
        "tier": null,
        "isStatic": false,
        "gain": null,
        "preview": null
    },
    {
        "path": "/exports/",
        "anchor": null,
        "href": "/exports/",
        "label": "Export des tirages",
        "desc": "CSV, Excel et PDF de la période choisie",
        "icon": "download",
        "tier": "premium",
        "isStatic": false,
        "gain": "Les tirages et les statistiques de la période choisie à télécharger : CSV, Excel prêt à l'emploi ou PDF à imprimer, avec Premium.",
        "preview": "/images/outils/exports.webp"
    },
    {
        "path": "/keno-regles/",
        "anchor": null,
        "href": "/keno-regles/",
        "label": "Règles du Keno",
        "desc": "La formule 2025 expliquée simplement",
        "icon": "book",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/keno-probabilites/",
        "anchor": null,
        "href": "/keno-probabilites/",
        "label": "Probabilités",
        "desc": "Vos chances pour chaque grille, de 4 à 10 numéros",
        "icon": "dices",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/comment-gagner-keno/",
        "anchor": null,
        "href": "/comment-gagner-keno/",
        "label": "Comment gagner au Keno",
        "desc": "Ce qui est possible et ce qui ne l'est pas",
        "icon": "target",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/combien-numeros-jouer-keno/",
        "anchor": null,
        "href": "/combien-numeros-jouer-keno/",
        "label": "Combien de numéros jouer",
        "desc": "De 4 à 10 numéros : que choisir",
        "icon": "grid",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/keno-mythes-vs-realite/",
        "anchor": null,
        "href": "/keno-mythes-vs-realite/",
        "label": "Mythes et réalité",
        "desc": "Les idées reçues passées au crible",
        "icon": "activity",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/guide-systemes-reducteurs/",
        "anchor": null,
        "href": "/guide-systemes-reducteurs/",
        "label": "Guide des réducteurs",
        "desc": "Comprendre les systèmes réducteurs",
        "icon": "book",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/loi-hypergeometrique-keno/",
        "anchor": null,
        "href": "/loi-hypergeometrique-keno/",
        "label": "Loi hypergéométrique",
        "desc": "Le calcul derrière les probabilités du Keno",
        "icon": "calculator",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/gagner-keno-4-numeros/",
        "anchor": null,
        "href": "/gagner-keno-4-numeros/",
        "label": "Jouer 4 numéros",
        "desc": "Probabilités et gains avec 4 numéros",
        "icon": "target",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/gagner-keno-5-numeros/",
        "anchor": null,
        "href": "/gagner-keno-5-numeros/",
        "label": "Jouer 5 numéros",
        "desc": "Probabilités et gains avec 5 numéros",
        "icon": "target",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/gagner-keno-6-numeros/",
        "anchor": null,
        "href": "/gagner-keno-6-numeros/",
        "label": "Jouer 6 numéros",
        "desc": "Probabilités et gains avec 6 numéros",
        "icon": "target",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/gagner-keno-7-numeros/",
        "anchor": null,
        "href": "/gagner-keno-7-numeros/",
        "label": "Jouer 7 numéros",
        "desc": "Probabilités et gains avec 7 numéros",
        "icon": "target",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/gagner-keno-8-numeros/",
        "anchor": null,
        "href": "/gagner-keno-8-numeros/",
        "label": "Jouer 8 numéros",
        "desc": "Probabilités et gains avec 8 numéros",
        "icon": "target",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/gagner-keno-9-numeros/",
        "anchor": null,
        "href": "/gagner-keno-9-numeros/",
        "label": "Jouer 9 numéros",
        "desc": "Probabilités et gains avec 9 numéros",
        "icon": "target",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/gagner-keno-10-numeros/",
        "anchor": null,
        "href": "/gagner-keno-10-numeros/",
        "label": "Jouer 10 numéros",
        "desc": "Probabilités et gains avec 10 numéros",
        "icon": "target",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/comparatif-nouvelle-formule-keno/",
        "anchor": null,
        "href": "/comparatif-nouvelle-formule-keno/",
        "label": "Avant et après 2025",
        "desc": "Ce qui a changé avec la nouvelle formule",
        "icon": "repeat",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/jeu-responsable/",
        "anchor": null,
        "href": "/jeu-responsable/",
        "label": "Jeu responsable",
        "desc": "Garder le jeu un plaisir",
        "icon": "shield",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/tarifs/",
        "anchor": null,
        "href": "/tarifs/",
        "label": "Tarifs",
        "desc": "Le compte gratuit et les formules Premium",
        "icon": "coins",
        "tier": null,
        "isStatic": false,
        "gain": null,
        "preview": null
    },
    {
        "path": "/contact/",
        "anchor": null,
        "href": "/contact/",
        "label": "Contact",
        "desc": "Une question, une remarque",
        "icon": "link",
        "tier": null,
        "isStatic": false,
        "gain": null,
        "preview": null
    },
    {
        "path": "/donnees-keno-open-data/",
        "anchor": null,
        "href": "/donnees-keno-open-data/",
        "label": "Données ouvertes",
        "desc": "L'historique en CSV et JSON, licence CC-BY 4.0",
        "icon": "download",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/alternative-kenolab/",
        "anchor": null,
        "href": "/alternative-kenolab/",
        "label": "Alternative à KenoLab",
        "desc": "KenoMetric face à KenoLab",
        "icon": "compare",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/alternative-secrets-du-jeu/",
        "anchor": null,
        "href": "/alternative-secrets-du-jeu/",
        "label": "Alternative à Secrets du Jeu",
        "desc": "KenoMetric face à Secrets du Jeu",
        "icon": "compare",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/alternative-keno-expert/",
        "anchor": null,
        "href": "/alternative-keno-expert/",
        "label": "Alternative à Keno Expert",
        "desc": "Keno Expert et le Keno de la FDJ",
        "icon": "compare",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/legal/",
        "anchor": null,
        "href": "/legal/",
        "label": "Mentions légales",
        "desc": "Éditeur et hébergeur du site",
        "icon": "book",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/cgu/",
        "anchor": null,
        "href": "/cgu/",
        "label": "CGU",
        "desc": "Conditions générales d'utilisation",
        "icon": "book",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/cgv/",
        "anchor": null,
        "href": "/cgv/",
        "label": "CGV",
        "desc": "Conditions générales de vente",
        "icon": "book",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/confidentialite/",
        "anchor": null,
        "href": "/confidentialite/",
        "label": "Confidentialité",
        "desc": "Vos données et vos droits",
        "icon": "shield",
        "tier": null,
        "isStatic": true,
        "gain": null,
        "preview": null
    },
    {
        "path": "/calendrier/",
        "anchor": null,
        "href": "/calendrier/",
        "label": "Calendrier des tirages",
        "desc": "Les numéros sortis selon le jour de la semaine",
        "icon": "calendar",
        "tier": "account",
        "isStatic": false,
        "gain": "Les numéros sortis selon le jour de la semaine, tirage par tirage.",
        "preview": "/images/outils/calendrier.webp"
    }
];

/** Adresses dynamiques rattachées à une rubrique (préfixe vers clé). */
export const NAV_PREFIXES: Record<string, NavRubriqueKey> = {
    "/tirage/": "resultats",
    "/analyses/tirage/": "resultats",
    "/pronostic/": "pronostics",
    "/numero/": "statistiques"
};

/** Les analyses du Labo (bloc « Les autres analyses du Labo »), même liste que la page Twig. */
export const NAV_LABO_OUTILS: { slug: string; label: string; desc: string }[] = [
    {
        "slug": "numeros-plus-sortis-keno",
        "label": "Top numéros sur une période",
        "desc": "Les plus sortis entre deux dates de votre choix."
    },
    {
        "slug": "taux-sortie-numeros-keno",
        "label": "Taux de sortie et théorie",
        "desc": "Fréquence réelle de chaque numéro face au taux de 16 sur 56."
    },
    {
        "slug": "numeros-signature-keno",
        "label": "Numéros signature",
        "desc": "Les numéros en tête sur plusieurs fenêtres de tirages."
    },
    {
        "slug": "analyse-combinaison-keno",
        "label": "Analyse de combinaison",
        "desc": "Vos numéros face à tout l'historique des tirages."
    }
];

/** Premier tirage de la formule 2025 en base. */
export const NAV_PREMIER_TIRAGE = "2025-11-03";
